import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { State } from 'src/app/shared/models/State';
import { ChurchAdressVO } from 'src/app/shared/models/ChurchAdressVO';
import { GuideModel } from 'src/app/shared/models/guide-model';
import { Wstype } from 'src/app/shared/models/Wstype';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { Form0 } from 'src/app/shared/models/Form0';
import * as moment from 'moment';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { Form0WrpVO } from 'src/app/shared/models/Form0WrpVO';
import { PeriodsVO } from 'src/app/shared/models/PeriodsVO';
import { TranslateService } from '@ngx-translate/core';
import { TovpilLangService } from 'src/app/utils/tovpil-lang.service';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';


@Component({
  selector: 'app-workshop-detail',
  templateUrl: './workshop-detail.component.html',
  styleUrls: ['./workshop-detail.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class WorkshopDetailComponent implements OnInit {

  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  typeRedirect: any;
  reqApprove: any;
  storeIdParam: string;

  workShopDetail: any;
  listState: State[];
  selectedState: State;
  listParishes: ChurchAdressVO[];
  selectedParis: ChurchAdressVO;
  listGuidesStore: GuideModel[];
  listGuidesStoreActiv: GuideModel[];
  listGuidesStore2: GuideModel[];
  listGuidesStore3: GuideModel[];
  selectedGuideStore: GuideModel;
  selectedGuideStore2: GuideModel;
  selectedGuideStore3: GuideModel;
  listWorkshopType: Wstype[];
  selectedWorkshopType: Wstype = null;
  anioPeriod: number;
  currentYear: number;
  numberPeriodo: number;
  sessNum: number;
  startDate: Date;
  endDate: Date;
  startTime: Date;
  endTime: Date;
  sessDay: String;
  comments: String;
  listLanguage: ValuesVO[];
  selectedLanguage: ValuesVO;
  visibleMateGuide: boolean;
  selectedPeriod: PeriodsVO;

  date1: Date;
  disabled: boolean;
  cities: any[];
  value1: number;
  schoolFPG: any;
  schoolSerTyp: string;
  partici1s2s: any;
  particiDes: any;
  createDate: any;
  visiblePartici1s2s: boolean;
  visibleparticiDes: boolean;

  dataParent: any;

  canEditDisabled: boolean = false;
  profileUser: any;
  minDate: Date;
  maxDate: Date;

  lbl_go_Back: string = "back_";
  lbl_workshop: string = "workshop_";
  lbl_state: string = "state_";
  lbl_select: string = "select_";
  lbl_church_name_: string = "church_name_";
  lbl_year: string = "year_";
  lbl_period: string = "period_";
  lbl_type: string = "type_";
  lbl_language: string = "language_";
  lbl_guide_imparts: string = "guide_imparts_";
  lbl_schedule: string = "schedule_";
  lbl_starting_date: string = "starting_date_";
  lbl_ending_date: string = "ending_date_";
  lbl_sessions: string = "sessions_";
  lbl_number: string = "number_";
  lbl_day: string = "day_";
  lbl_starting_time: string = "starting_time_";
  lbl_ending_time: string = "ending_time_";
  lbl_comments: string = "comments_";
  lbl_save: string = "save_";
  lbl_delete: string = "delete_record_";
  lbl_mate_guide_refunding: string = "guide_mate_see_refunding_cases";
  lbl_second_leading_guide = "second_leading_guide_";
  lbl_are_you_sure = "are_you_sure_";
  lbl_update = "update_";
  lbl_confirm = "confirm_";
  lbl_delete_record_ = "delete_record_";
  lbl_yes: string = "yes_";
  lbl_no: string = "no_";
  lbl_participants_1st: string = "participants_2nd_sesion_";
  lbl_particp15s: string = "10a15a_particip_";
  lbl_lastSessionPart: string;
  lbl_participants: string = "participants_";
  lbl_partner_guide: string = "partner_guide_";
  lbl_session: string = "session_";
  lbl_husband_wife = "husband_wife_";



  schoolFpgDetailRedirect: any = null;

  listWeekDays: CategoryLan[];
  selectedWeekDay: CategoryLan;

  endPointFindPropertiesByKey = "findPropertiesByKey";

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private tovpilLang: TovpilLangService,
    public translate: TranslateService,
    private tovpilCrudService: TovpilCrudService,
    public primeNGConfig: PrimeNGConfig) {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;
    this.currentYear = new Date().getFullYear();

    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
      });

    // Sino hay componente padre se consulta la información en local
    if (!this.dataParent) {
      const storedWorkshopData = localStorage.getItem('workshopData');
      this.dataParent = storedWorkshopData ? JSON.parse(storedWorkshopData) : null;
    }

    // Se establece el objecto de redireccion previo su eliminacion
    localStorage.removeItem('workshopData');
    localStorage.setItem('workshopData', JSON.stringify(this.dataParent));
  }

  ngOnInit(): void {

    if (this.dataParent) {
      this.storeIdParam = this.dataParent.storeIdParam;
      this.selectedPeriod = this.dataParent.selectedPeriod;
      this.workShopDetail = this.dataParent.workshop;

      this.typeRedirect = this.dataParent.type;

      this.reqApprove = this.dataParent.reqApprove;
      this.schoolFpgDetailRedirect = this.dataParent.eppg;
      this.security = this.dataParent.security;

      this.getSecurity();
    } else {
      this.redirectWorkShop();
    }

  }

  redirectWorkShop() {
    // Establecemos temporalmente el objeto por modificaciones , recargar, etc.
    // Posteior a ello se elimina
    localStorage.removeItem('workshopData');

    let queryParamsDetail = {}
    if (this.token && this.device) {
      queryParamsDetail = {
        token: this.token,
        device: this.device
      }
    }
    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail
    }

    switch (this.typeRedirect) {
      case 'W':
        this.router.navigate(['guide/workshops'], navigationExtras);
        break;
      case 'S':
        this.redirectSchoolFpgDetail();
        break;
      case 'WM':
        this.redirectWorkshopMng();
        break;
      default:
        this.router.navigate(['guide/workshops'], navigationExtras);
        // Handle default case, if needed
        break;
    }
  }

  redirectWorkshopMng() {
    let queryParamsDetail = {}

    if (this.storeIdParam) {
      queryParamsDetail = {
        ...queryParamsDetail,
        storeId: this.storeIdParam,
        year: this.selectedPeriod.year,
        period: this.selectedPeriod.period
      }
    }
    if (this.token && this.device) {
      queryParamsDetail = {
        ...queryParamsDetail,
        token: this.token,
        device: this.device,
        storeId: this.storeIdParam
      }
    }

    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail
    }

    this.router.navigate(['/secretary/wrkshopMngComponent'], navigationExtras);
  }

  /**
 * This function navigates to the workshop detail page with the selected workshop and security
 * information.
 * @param {any} school - This parameter is an object that represents the selected workshop. It is
 * passed as an argument to the function `openSchoolFpgDetail()`.
 */
  redirectSchoolFpgDetail() {

    let obj = {
      eppg: this.schoolFpgDetailRedirect,
      security: this.security
    }


    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }
    this.router.navigate(['/catalogs/eppgs/schoolfpgDetail'], navigationExtras);
  }

  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          if (!this.storeIdParam) {
            this.storeIdParam = this.security.storeId;
          }
          this.tovpilLang.translate(this.security.language)

          this.getWeekDays();
          this.getStatesByCountry();
          this.getGuidesByStore();
          this.getWorkShoptype();
          this.getLanguages();
          this.getTranslatedLabels();

        });
    } else {
      this.tovpilLang.translate(this.security.language)
      if (!this.storeIdParam) {
        this.storeIdParam = this.security.storeId;
      }
      this.getWeekDays();
      this.getStatesByCountry();
      this.getGuidesByStore();
      this.getWorkShoptype();
      this.getLanguages();
      this.getTranslatedLabels();

    }
    if (!this.workShopDetail) {
      this.getPeriodToday();
    }


  }

  getWeekDays() {
    this.apiService.getCategoryLang({
      'language': this.security.language,
      'fieldId': "weekDays"
    }).then(categoryLangResp => {
      this.listWeekDays = categoryLangResp;
    });

  }


  getStatesByCountry() {
    //console.log(this.workShopDetail);
    this.apiService.getStatesFromStore(
      {
        "storeId": this.storeIdParam ? this.storeIdParam : this.security.storeId
      }
    ).then(
      data => {
        this.listState = data;

        if (this.workShopDetail) {
          this.selectedState = this.listState.find(s => s.id.stateId === this.workShopDetail.addr.state);
        }
        this.getGuideProfileServices();


      });

  }

  getChurches() {
    this.listParishes = [];
    const body = {
      country: this.selectedState.id.countryId,
      state: this.selectedState.id.stateId,
      name: ""
    };

    this.apiService.getChurchsByCountryState(body).then(
      data => {
        this.listParishes = data;

        this.checkIfGuideImpartsSchool();

        this.listParishes = this.listParishes.map((ChurchAdressVO: any) => {
          return {
            ...ChurchAdressVO,
            name: ChurchAdressVO.name + ': ' + ChurchAdressVO.zipCode + ' ' + ChurchAdressVO.street + ' ' + ChurchAdressVO.neight + ' ' + ChurchAdressVO.city + ', ' + ChurchAdressVO.state
          };
        });

      });

  }


  getGuidesByStore() {
    const lstStr = [];

    lstStr.push(this.storeIdParam);

    let listGuidesStoreTmp: GuideModel[];
    this.listGuidesStore = [];
    this.listGuidesStore2 = [];
    this.listGuidesStore3 = [];
    this.listGuidesStoreActiv = [];
    this.apiService.getGuidesByStore({ lstStr: lstStr }).then(
      data => {
        this.listGuidesStore = data;

        if (this.workShopDetail) {
          this.selectedGuideStore = this.listGuidesStore.find(g => g.guideId === this.workShopDetail.f0.guideId);
          this.selectedGuideStore2 = this.listGuidesStore.find(g => g.guideId === this.workShopDetail.f0.mateGuideId);
          this.selectedGuideStore3 = this.listGuidesStore.find(g => g.guideId === this.workShopDetail.f0.assistGuideId);
          this.reloadMainGuides(this.workShopDetail.f0.serTyp);
        } else {
          this.reloadMainGuides('02');
        }


      });
  }
  listPartnerGuides() {
    let storeId: String;
    let listGuidesStoreTmp: GuideModel[];
    this.listGuidesStore2 = [];
    this.listGuidesStore3 = [];

    storeId = this.storeIdParam;

    this.apiService.listPartnerGuides({
      "storeId": storeId,
      "serTyp": this.selectedWorkshopType.wsId,
      "guideId": this.security.guideId
    }).then(
      data => {
        this.listGuidesStore2 = data;
        this.listGuidesStore2.forEach((element) => {
          this.listGuidesStore3.push(element);
        });
        if (this.selectedGuideStore2) {
          this.listGuidesStore2.push(this.selectedGuideStore2);
        }
        if (this.selectedGuideStore3) {
          this.listGuidesStore3.push(this.selectedGuideStore3);
        }

        this.listGuidesStore2 = this.listGuidesStore2.map((guide: any) => {
          return {
            ...guide,
            fullName: guide.name + ' ' + guide.lastName
          };
        });
        this.listGuidesStore3 = this.listGuidesStore3.map((guide: any) => {
          return {
            ...guide,
            fullName: guide.name + ' ' + guide.lastName
          };
        });
        if (this.workShopDetail) {
          this.selectedGuideStore2 = this.listGuidesStore2.find(g => g.guideId === this.workShopDetail.f0.mateGuideId);
          this.selectedGuideStore3 = this.listGuidesStore3.find(g => g.guideId === this.workShopDetail.f0.assistGuideId);
        }
      }).catch(error => {
        console.error(error);

      });
  }


  getWorkShoptype() {
    const body = {

      guideId: this.security.guideId ? this.security.guideId : "00",
      language: this.security.language,
      transaction: this.workShopDetail != null && this.workShopDetail.f0 != null && this.workShopDetail.f0.wrksId ? "UPDATE" : ""
    };
    this.listWorkshopType = [];
    this.apiService.listWstypeByGuideType(body).then(
      data => {
        this.listWorkshopType = data;
        if (this.workShopDetail) {

          this.selectedWorkshopType = this.listWorkshopType.find(t => t.wsId === this.workShopDetail.f0.serTyp);
        } else if (this.schoolFPG) {
          this.selectedWorkshopType = this.listWorkshopType.find(t => t.wsId === this.schoolSerTyp);
        }
        if (!this.selectedWorkshopType) {
          this.selectedWorkshopType = this.listWorkshopType[0];
        }
        // this.sessNum = this.selectedWorkshopType.sesNum;
        this.sessNum = this.selectedWorkshopType != null ? Number(this.selectedWorkshopType.sesNum) + Number(this.selectedWorkshopType.openSesEx ? '1' : '0') + Number(this.selectedWorkshopType.hasDesert ? '1' : '0') : 0;
        this.onSelectInitialTime();
        this.loadDataDetail();
        this.checkMateLabel();
      });
  }

  getLanguages() {
    const body = {
      storeId: this.storeIdParam,
      language: this.security.language
    }
    this.apiService.getListSpkLangByStoreId(body).then(
      data => {
        this.listLanguage = data;

        if (this.workShopDetail) {
          this.selectedLanguage = this.listLanguage.find(l => l.valueId === this.workShopDetail.f0.language);
        }
        if (!this.selectedLanguage) {
          this.selectedLanguage = this.listLanguage[0];
        }
      });
  }

  getPeriodToday() {

    if (this.dataParent.selectedPeriod) {
      this.anioPeriod = this.dataParent.selectedPeriod.year;
      this.numberPeriodo = this.dataParent.selectedPeriod.period;
    } else {
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth() + 1;
      let period = currentMonth < 7 ? 1 : 2;
      this.anioPeriod = currentYear;
      this.numberPeriodo = period;
    }
  }

  loadDataDetail() {
    if (this.workShopDetail != null) {

      this.anioPeriod = +this.workShopDetail.f0.anio;
      this.numberPeriodo = +this.workShopDetail.f0.period;
      this.startTime = this.tovpilUtils.convertStringToDateTime(this.workShopDetail.f0.fromTime);
      this.endTime = this.tovpilUtils.convertStringToDateTime(this.workShopDetail.f0.toTime);
      this.createDate = this.workShopDetail.f0.createDate

      this.sessNum = this.selectedWorkshopType != null ? Number(this.selectedWorkshopType.sesNum) + Number(this.selectedWorkshopType.openSesEx ? '1' : '0') + Number(this.selectedWorkshopType.hasDesert ? '1' : '0') : 0;

      this.startDate = this.workShopDetail.f0.strDate != null ? this.tovpilUtils.convertStringToDate(this.workShopDetail.f0.strDate) : null;
      this.endDate = this.workShopDetail.f0.endDate != null ? this.tovpilUtils.convertStringToDate(this.workShopDetail.f0.endDate) : null;
      this.comments = this.workShopDetail.f0.comment != null ? this.workShopDetail.f0.comment : '';
      this.selectedWeekDay = this.listWeekDays.find(day => day.fieldVal == this.workShopDetail.f0.weekDay);

      this.partici1s2s = this.workShopDetail.f0.partN2s != null ? this.workShopDetail.f0.partN2s : 0;
      this.particiDes = this.workShopDetail.f0.partN15s != null ? this.workShopDetail.f0.partN15s : 0

      //Permiir editar en cualquier estatus, pero posteriormente ya no permitirlo
      if ((this.workShopDetail.f0.status == 'P' || this.workShopDetail.f0.status == 'N' || this.workShopDetail.f0.status == 'A' || this.workShopDetail.f0.serTyp == '16' || this.workShopDetail.f0.serTyp == '17' || this.workShopDetail.f0.serTyp == '18')) {
        this.canEditDisabled = false;
      } else {
        this.canEditDisabled = true;
      }

      this.visibleparticiDes = false;
      if (this.security.levelId != 'G' && this.workShopDetail.f0.serTyp != "16" && this.workShopDetail.f0.serTyp != "17" && this.workShopDetail.f0.serTyp != "18") {
        this.visiblePartici1s2s = true;
        if (Number(this.workShopDetail.wst.sesNum) > 1) {
          this.visibleparticiDes = true;

        }

      } else {
        this.visiblePartici1s2s = false;
      }

    }


  }

  onSelectInitialDate() {
    if (this.endDate < this.startDate) {
      // console.debug("Se intento poner una fecha de inicio mayor a la fecha de termino");
      this.endDate = null;
    }
    this.sessDay = this.startDate.toLocaleString(this.security.language, { weekday: 'long' });
    this.sessDay = this.sessDay.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    this.selectedWeekDay = this.listWeekDays.find(day => day.descrip.toLowerCase() === this.sessDay);
  }

  async onUpdateMinMaxByPeriodYear() {
    const fetchFutureGuideData = async (): Promise<number> => {
      try {
        const result = await this.tovpilCrudService.fetch(this.endPointFindPropertiesByKey, {
          "key": "days_to_entry_service"
        });

        if (result.success && Array.isArray(result.data) && result.data.length > 0) {
          return result.data[0]['value'];
        }

        return 720;
      } catch (error) {
        console.error("Error fetching data:", error);
        return 720;  // Valor por defecto
      }
    };

    const days = await fetchFutureGuideData();
    const currentDate = new Date();

    // Ajustamos las fechas
    this.minDate = this.adjustDate(currentDate, -days);  // Restamos los días de minDate
    this.maxDate = this.adjustDate(currentDate, days);   // Sumamos los días a maxDate
  }

  adjustDate(date: Date, days: number): Date {
    const timeInMilliseconds = date.getTime();
    const daysInMilliseconds = days * 24 * 60 * 60 * 1000;
    const newDate = new Date(timeInMilliseconds + daysInMilliseconds);

    return newDate;
  }

  onSelectInitialTime() {
    let duration: number = +this.selectedWorkshopType.duration;
    this.endTime = moment(this.startTime).add(duration, 'm').toDate();
  }

  saveUpdateWorkShop() {
    this.confirmationService.confirm({
      message: this.lbl_are_you_sure + " " + this.lbl_update + " " + this.lbl_workshop + "?",
      header: this.lbl_confirm + " " + this.lbl_update,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.lbl_yes,
      rejectLabel: this.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.createUpdateWorkShop();
      }
    });
  }

  createUpdateWorkShop() {
    let resp: Form0WrpVO;
    let storeId: string;

    let status: string;
    if (this.security.levelId == 'G') {
      status = 'N'
    } else {
      status = 'P';
    }

    let wrksId = this.workShopDetail != null && this.workShopDetail.f0 != null ? this.workShopDetail.f0.wrksId : null;
    if (this.reqApprove && this.reqApprove == 'true') {
      status = 'P';
    } else if (this.workShopDetail != null && this.workShopDetail.f0 != null && this.workShopDetail.f0.status) {
      status = this.workShopDetail.f0.status;
    }

    storeId = this.storeIdParam;

    let workshop: Form0 = {
      wrksId: this.workShopDetail != null && this.workShopDetail.f0 != null ? this.workShopDetail.f0.wrksId : null,
      churchId: this.selectedParis != null ? this.selectedParis.churchId : null,
      addrId: this.selectedParis != null ? this.selectedParis.address : null,
      comment: this.comments != null ? this.comments.toString() : "",
      status: status,
      guideId: this.selectedGuideStore.guideId,
      serTyp: this.selectedWorkshopType != null ? this.selectedWorkshopType.wsId : null,
      storeId: storeId,
      strDate: this.startDate != null ? this.tovpilUtils.dateToTovpilDate(this.startDate) : null,
      endDate: this.endDate != null ? this.tovpilUtils.dateToTovpilDate(this.endDate) : null,
      fromTime: this.startTime != null ? this.tovpilUtils.dateToTovpilOnlyTime(this.startTime) : null,
      toTime: this.endTime != null ? this.tovpilUtils.dateToTovpilOnlyTime(this.endTime) : null,
      language: this.selectedLanguage != null ? this.selectedLanguage.valueId : null,
      period: this.numberPeriodo != null ? this.numberPeriodo.toString() : null,
      anio: this.anioPeriod != null ? this.anioPeriod.toString() : null,
      weekDay: this.selectedWeekDay != null ? this.selectedWeekDay.fieldVal : null,
      mateGuideId: this.selectedGuideStore2 != null ? this.selectedGuideStore2.guideId : "",
      assistGuideId: this.selectedGuideStore3 != null ? this.selectedGuideStore3.guideId : "",
      partN2s: this.partici1s2s,
      partN15s: this.particiDes,
      toPost: this.workShopDetail != null && this.workShopDetail.f0 != null ? this.workShopDetail.f0.toPost : true,
      createDate: this.createDate
    };


    this.apiService.createUpdateCancelForm0Wrp(
      {
        language: this.security.language,
        form0: workshop,
      }
    ).then(
      data => {

        if (data && data.status.trim() == 'OK') {

          if (this.schoolFPG) {
            this.updateWSinSchoolFpg(data.form0.wrksId);
          }
          this.messageService.add({ severity: 'success', summary: 'Actualización servicio', detail: "Se creo servicio correctamente", life: 5000 });
          this.redirectWorkShop();
        } else {
          this.messageService.add({ severity: 'error', summary: 'ERROR: ' + data.errorMessage, detail: " ", life: 10000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Actualización servicio' + error + "/", detail: "Error al Actualizar servicio" + error + "/", life: 3000 });
      });

  }

  deleteWorkShop() {
    this.confirmationService.confirm({
      message: this.lbl_are_you_sure + " " + this.lbl_delete_record_ + "?",
      header: this.lbl_confirm + " " + this.lbl_delete_record_,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.lbl_yes,
      rejectLabel: this.lbl_no,
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteWorkShopService();
      }
    });
  }


  deleteWorkShopService() {


    let form0: Form0WrpVO = {
      form0: {
        wrksId: this.workShopDetail.f0.wrksId,
        cancelSts: 'X'
      },
      language: this.security.language
    }

    this.apiService.createUpdateCancelForm0Wrp(form0).then(
      data => {
        if (data && data.status.trim() == 'OK') {
          if (this.schoolFPG) {
            this.cleanSchoolService();
          }

          this.messageService.add({ severity: 'success', summary: 'Creación servicio', detail: "Se elimino servicio correctamente", life: 3000 });
          this.redirectWorkShop();
        } else {
          this.messageService.add({ severity: 'error', summary: 'ERROR: ' + data.errorMessage, detail: " ", life: 10000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Creación servicio', detail: "Error al eliminar servicio", life: 3000 });
      });


  }

  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_workshop, this.lbl_state, this.lbl_select, this.lbl_church_name_, this.lbl_year, this.lbl_period, this.lbl_type, this.lbl_language, this.lbl_guide_imparts, this.lbl_schedule, this.lbl_starting_date, this.lbl_ending_date, this.lbl_sessions, this.lbl_number, this.lbl_day, this.lbl_starting_time, this.lbl_ending_time, this.lbl_comments, this.lbl_save, this.lbl_delete, this.lbl_mate_guide_refunding, this.lbl_second_leading_guide, this.lbl_are_you_sure, this.lbl_update, this.lbl_confirm, this.lbl_delete_record_, this.lbl_yes, this.lbl_no, this.lbl_participants_1st, this.lbl_particp15s, this.lbl_partner_guide, this.lbl_participants, this.lbl_session, this.lbl_husband_wife]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_state = map.get(this.lbl_state);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_church_name_ = map.get(this.lbl_church_name_);
        this.lbl_year = map.get(this.lbl_year);
        this.lbl_period = map.get(this.lbl_period);
        this.lbl_type = map.get(this.lbl_type);
        this.lbl_language = map.get(this.lbl_language);
        this.lbl_guide_imparts = map.get(this.lbl_guide_imparts);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_starting_date = map.get(this.lbl_starting_date);
        this.lbl_ending_date = map.get(this.lbl_ending_date);
        this.lbl_sessions = map.get(this.lbl_sessions);
        this.lbl_number = map.get(this.lbl_number);
        this.lbl_day = map.get(this.lbl_day);
        this.lbl_starting_time = map.get(this.lbl_starting_time);
        this.lbl_ending_time = map.get(this.lbl_ending_time);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_delete = map.get(this.lbl_delete);

        this.lbl_second_leading_guide = map.get(this.lbl_second_leading_guide);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_update = map.get(this.lbl_update);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_yes = map.get(this.lbl_yes);
        this.lbl_no = map.get(this.lbl_no);
        this.lbl_participants_1st = map.get(this.lbl_participants_1st);
        this.lbl_particp15s = map.get(this.lbl_particp15s);
        this.lbl_partner_guide = map.get(this.lbl_partner_guide);
        this.lbl_mate_guide_refunding = map.get(this.lbl_mate_guide_refunding);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_session = map.get(this.lbl_session);
        this.lbl_husband_wife = map.get(this.lbl_husband_wife);

        if (this.workShopDetail) {
          if (this.workShopDetail.wst.hasDesert) {
            this.lbl_lastSessionPart = this.lbl_particp15s;
          } else {
            this.lbl_lastSessionPart = this.lbl_participants + " " + this.lbl_session + " " + this.workShopDetail.wst.sesNum
          }
        }
      });
  }
  checkMateLabel() {

    if (this.selectedWorkshopType != null) {
      if (this.selectedWorkshopType.wsId == Constants.SERTYPE_TEEN || this.selectedWorkshopType.wsId == Constants.SERTYPE_CHILDS) {
        this.visibleMateGuide = false;
      } else {
        this.visibleMateGuide = true;
      }

      this.sessNum = this.selectedWorkshopType != null ? Number(this.selectedWorkshopType.sesNum) + Number(this.selectedWorkshopType.openSesEx ? '1' : '0') + Number(this.selectedWorkshopType.hasDesert ? '1' : '0') : 0;
      this.onSelectInitialTime();
      this.listPartnerGuides();
      this.reloadMainGuides(this.selectedWorkshopType.wsId);
    }


  }
  async getGuideProfileServices() {
    if (this.security && this.security.guideId) {
      await this.apiService.getGuideProfile({ guideId: this.security.guideId }).then(
        data => {
          this.profileUser = data;
          if (!this.selectedState && this.profileUser) {
            this.selectedState = this.listState.find(s => s.descrip === this.profileUser.address.state);
          }
        }).catch(error => {
          this.messageService.add({ key: "tst", severity: 'error', summary: 'ocurrio un error: ' + error + "/", detail: " ", life: 3000 });
        });
    }
    if (!this.selectedState) {
      this.selectedState = this.listState[0];
    }
    this.getChurches();
  }

  filteredChurchs: ChurchAdressVO[];
  filterChurch(event) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.listParishes.length; i++) {
      let church = this.listParishes[i]; // Original data from service
      if (church.name.toLowerCase().includes(query.toLowerCase())) {
        filtered.push(church);
      }
    }

    this.filteredChurchs = filtered;
  }
  updateWSinSchoolFpg(wrksId: string) {
    if (this.selectedWorkshopType.wsId == '16') {
      this.schoolFPG.wrksId01 = wrksId;
    } else if (this.selectedWorkshopType.wsId == '17') {
      this.schoolFPG.wrksId02 = wrksId;
    } if (this.selectedWorkshopType.wsId == '18') {
      this.schoolFPG.wrksId03 = wrksId;
    }
    if (this.schoolFPG.fromTime) {
      let time: string[];
      time = this.schoolFPG.fromTime.split(":");
      this.schoolFPG.fromTime = time[0] + time[1];
    }
    this.apiService.updateSchoolFPG(this.schoolFPG).then(
      data => {
        if (data) {

        }
      });

  }
  cleanSchoolService() {
    if (this.selectedWorkshopType.wsId == '16') {
      this.schoolFPG.wrksId01 = "";
    } else if (this.selectedWorkshopType.wsId == '17') {
      this.schoolFPG.wrksId02 = "";
    } if (this.selectedWorkshopType.wsId == '18') {
      this.schoolFPG.wrksId03 = "";
    }
    if (this.schoolFPG.fromTime) {
      let time: string[];
      time = this.schoolFPG.fromTime.split(":");
      this.schoolFPG.fromTime = time[0] + time[1];
    }
    this.apiService.updateSchoolFPG(this.schoolFPG).then(
      data => {
        if (data) {

        }
      });

  }
  async checkIfGuideImpartsSchool() {
    await this.apiService.findOpenSchoolsByGuideId({
      "guideId": this.selectedGuideStore && this.selectedGuideStore.guideId ? this.selectedGuideStore.guideId : this.security.guideId
    }).then(
      data => {
        this.schoolFPG = data;
        if (this.schoolFPG) {
          if (!this.schoolFPG.wrksId01) {
            this.schoolSerTyp = '16';
          } else if (!this.schoolFPG.wrksId02) {
            this.schoolSerTyp = '17';
          } else if (!this.schoolFPG.wrksId03) {
            this.schoolSerTyp = '18';
          }
          // this.anioPeriod = this.schoolFPG.year;
          // this.numberPeriodo = this.schoolFPG.period;
        }
        if (this.workShopDetail) {
          this.selectedParis = this.listParishes.find(p => p.churchId === this.workShopDetail.chr.churchId);
        } else if (this.schoolFPG) {
          this.startTime = this.tovpilUtils.convertStringToDateTime(this.schoolFPG.fromTime);
          this.selectedParis = this.listParishes.find(p => p.churchId === this.schoolFPG.churchId);
        }
      });
  }
  reloadMainGuides(serTyp: string) {
    this.listGuidesStoreActiv = [];
    let load: Boolean = false;
    this.listGuidesStore.forEach((element) => {

      if (element.status == 'A') {
        load = true;

        if (serTyp == Constants.SERTYPE_MARRIAGE) {
          if (element.guiType != Constants.GUIDE__TYPE_OTHER && element.guiType != Constants.GUIDE_TYPE) {
            load = false;
          }
        } else if (serTyp == Constants.SERTYPE_ADULT || serTyp == Constants.SERTYPE_YOUNG) {

          if (element.guiType == Constants.GUIDE_TYPE || element.guiType == Constants.GUIDE_FUTURE_TYPE) {

          } else {
            load = false;
          }

        } else if (element.guiType != Constants.GUIDE_TYPE) {
          load = false;
        }

        if (load) {
          this.listGuidesStoreActiv.push(element);
        }
      }
    });

    if (this.selectedGuideStore) {
      this.listGuidesStoreActiv.push(this.selectedGuideStore);
    }
    this.listGuidesStoreActiv = this.listGuidesStoreActiv.map((guide: any) => {
      return {
        ...guide,
        fullName: guide.name + ' ' + guide.lastName
      };
    });

    if (this.workShopDetail) {
      this.selectedGuideStore = {};
      this.selectedGuideStore = this.listGuidesStoreActiv.find(g => g.guideId === this.workShopDetail.f0.guideId);
    } else {
      if (this.security.levelId == 'G') {
        this.selectedGuideStore = this.listGuidesStoreActiv.find(g => g.guideId === this.security.guideId);
      }
    }
  }

}
